import {useState} from "react";
import {NavLink, useNavigate} from "react-router-dom";
import {Bell, Search, Menu, XIcon} from "lucide-react";
import React from "react";
import {useSelector, useDispatch} from "react-redux";
import {assets} from "../../assets/assets";
import {useLogoutMutation} from "../../../src/features/userApiSlice";
import {logout} from "../../../src/features/authSlice";

export default function DashboardHeader({projectId}: {projectId: any}) {
    const [isSidebarOpen, setSidebarOpen] = useState(false);
    const {userInfo} = useSelector((state: any) => state.auth);
    const [logoutApiCall] = useLogoutMutation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const logoutHandler = async () => {
        try {
            //@ts-ignore
            await logoutApiCall().unwrap()
            //@ts-ignore
            dispatch(logout())
            navigate("/")
            ;
        } catch (error) {
            console.log(error);
        }
    }

    function MobileNavLink({
                               to,
                               label,
                               onClick,
                           }: {
        to: string;
        label: string;
        onClick: () => void;
    }) {

        return (

            <NavLink
                to={to}
                onClick={onClick}

                className={({ isActive }) => `
                flex
                min-h-[48px]

                items-center

                rounded-xl

                px-4

                text-sm
                font-medium

                transition

                ${
                    isActive
                        ? `
                            bg-blue-600/15
                            text-blue-400
                        `
                        : `
                            text-gray-300
                            hover:bg-gray-800
                            hover:text-white
                        `
                }
            `}
            >
                {label}
            </NavLink>
        );
    }

    return (
        <>
            <header
                className="
                    sticky
                    top-0
                    z-50

                    border-b
                    border-gray-800

                    bg-[#101010]/95
                    backdrop-blur-md
                "
            >

                <div
                    className="
                        mx-auto
                        w-full

                        px-4
                        sm:px-6
                        md:px-8
                        lg:px-8
                    "
                >

                    <div
                        className="
                            flex
                            h-16
                            items-center
                            justify-between
                        "
                    >


                        {/* ==================================================
                            LEFT SIDE
                        ================================================== */}

                        <div className="
                            flex
                            min-w-0
                            items-center
                            gap-3
                        ">


                            {/* ==================================================
                                HAMBURGER

                                Visible:
                                iPhone
                                iPad mini
                                iPad A16

                                Hidden:
                                Desktop
                            ================================================== */}

                            <button
                                type="button"

                                onClick={() =>
                                    setSidebarOpen(
                                        (prev) => !prev
                                    )
                                }

                                aria-label={
                                    isSidebarOpen
                                        ? "Close navigation menu"
                                        : "Open navigation menu"
                                }

                                aria-expanded={
                                    isSidebarOpen
                                }

                                className="
                                    lg:hidden

                                    flex
                                    h-11
                                    w-11
                                    shrink-0
                                    items-center
                                    justify-center

                                    rounded-xl

                                    text-gray-300

                                    hover:bg-gray-800
                                    hover:text-white

                                    active:scale-95

                                    transition
                                "
                            >

                                {isSidebarOpen ? (
                                    <XIcon size={24} />
                                ) : (
                                    <Menu size={24} />
                                )}

                            </button>


                            {/* ==================================================
                                LOGO
                            ================================================== */}

                            <NavLink
                                to="/"

                                onClick={() =>
                                    setSidebarOpen(false)
                                }

                                className="
                                    flex
                                    min-w-0
                                    items-center
                                    gap-2
                                "
                            >

                                <img
                                    src={
                                        assets.k_Solution_logo
                                    }

                                    alt="K Solution"

                                    className="
                                        h-9
                                        w-9
                                        shrink-0
                                        rounded-full
                                        object-cover
                                        shadow-md
                                    "
                                />


                                <h1 className="
                                    truncate
                                    text-lg
                                    sm:text-xl
                                    md:text-2xl
                                    font-semibold
                                    text-white
                                ">
                                    K Solution
                                </h1>

                            </NavLink>

                        </div>


                        {/* ==================================================
                            RIGHT SIDE
                        ================================================== */}

                        <div className="
                            flex
                            items-center
                            gap-1
                            sm:gap-3
                        ">


                            {/* SEARCH */}

                            <button
                                type="button"

                                aria-label="Search"

                                className="
                                    flex
                                    h-10
                                    w-10
                                    items-center
                                    justify-center

                                    rounded-lg

                                    text-gray-400

                                    hover:bg-gray-800
                                    hover:text-white

                                    transition
                                "
                            >
                                <Search size={20} />
                            </button>


                            {/* NOTIFICATIONS */}

                            <button
                                type="button"

                                aria-label="Notifications"

                                className="
                                    flex
                                    h-10
                                    w-10
                                    items-center
                                    justify-center

                                    rounded-lg

                                    text-gray-400

                                    hover:bg-gray-800
                                    hover:text-white

                                    transition
                                "
                            >
                                <Bell size={20} />
                            </button>


                            {/* ==================================================
                                USER
                            ================================================== */}

                            {userInfo ? (

                                <div className="
                                    flex
                                    items-center
                                    gap-2
                                ">


                                    {/* Avatar */}

                                    <div
                                        className="
                                            flex
                                            h-9
                                            w-9
                                            shrink-0

                                            cursor-pointer

                                            items-center
                                            justify-center

                                            rounded-full

                                            bg-purple-600

                                            text-sm
                                            font-semibold
                                            text-white
                                        "
                                    >
                                        {userInfo?.userName
                                            ?.charAt(0)
                                            ?.toUpperCase()}
                                    </div>


                                    {/* Email */}

                                    <span
                                        className="
                                            hidden
                                            lg:block

                                            max-w-[180px]

                                            truncate

                                            text-sm
                                            text-gray-300
                                        "
                                    >
                                        {userInfo?.email}
                                    </span>

                                </div>

                            ) : (

                                <NavLink
                                    to="/login"

                                    className="
                                        hidden
                                        sm:flex

                                        min-h-[40px]

                                        items-center
                                        justify-center

                                        rounded-lg

                                        bg-[#30E0A5]

                                        px-4

                                        text-sm
                                        font-semibold
                                        text-black

                                        hover:bg-[#30E0A5]/90

                                        transition
                                    "
                                >
                                    Log in
                                </NavLink>

                            )}

                        </div>

                    </div>

                </div>

            </header>


            {/* ================================================================
                MOBILE / TABLET SIDEBAR OVERLAY

                Visible below lg.

                iPhone:
                YES

                iPad mini:
                YES

                iPad A16:
                YES

                Desktop:
                NO
            ================================================================= */}

            {isSidebarOpen && (

                <>

                    {/* BACKDROP */}

                    <button
                        type="button"

                        aria-label="Close menu"

                        onClick={() =>
                            setSidebarOpen(false)
                        }

                        className="
                            fixed
                            inset-0
                            z-40

                            bg-black/60
                            backdrop-blur-sm

                            lg:hidden
                        "
                    />


                    {/* DRAWER */}

                    <aside
                        className="
                            fixed
                            left-0
                            top-0
                            z-50

                            h-dvh

                            w-[280px]
                            max-w-[85vw]

                            overflow-y-auto

                            border-r
                            border-gray-800

                            bg-[#101010]

                            shadow-2xl

                            lg:hidden

                            pt-[env(safe-area-inset-top)]
                            pb-[env(safe-area-inset-bottom)]
                        "
                    >


                        {/* DRAWER HEADER */}

                        <div className="
                            flex
                            h-16

                            items-center
                            justify-between

                            border-b
                            border-gray-800

                            px-4
                        ">


                            <div className="
                                flex
                                items-center
                                gap-2
                            ">

                                <img
                                    src={
                                        assets.k_Solution_logo
                                    }

                                    alt="K Solution"

                                    className="
                                        h-8
                                        w-8
                                        rounded-full
                                    "
                                />

                                <span className="
                                    font-semibold
                                    text-white
                                ">
                                    K Solution
                                </span>

                            </div>


                            <button
                                type="button"

                                onClick={() =>
                                    setSidebarOpen(false)
                                }

                                aria-label="
                                    Close navigation
                                "

                                className="
                                    flex
                                    h-10
                                    w-10

                                    items-center
                                    justify-center

                                    rounded-lg

                                    text-gray-400

                                    hover:bg-gray-800
                                    hover:text-white
                                "
                            >
                                <XIcon size={22} />
                            </button>

                        </div>


                        {/* NAVIGATION */}

                        <nav className="
                            flex
                            flex-col

                            gap-2

                            p-5
                        ">

                            <MobileNavLink
                                to={`/management/employeeMain/${projectId}`}
                                label="Emp WK Timesheet"
                                onClick={() =>
                                    setSidebarOpen(false)
                                }
                            />

                            <MobileNavLink
                                to={`/management/employeeList/${projectId}`}
                                label="Team Daily Attendance"
                                onClick={() =>
                                    setSidebarOpen(false)
                                }
                            />

                            <MobileNavLink
                                to={`/management/weeklytimesheet/${projectId}`}
                                label="Team WK Timesheet"
                                onClick={() =>
                                    setSidebarOpen(false)
                                }
                            />

                            <MobileNavLink
                                to={`/management/users/${projectId}`}
                                label="Users Configuration"
                                onClick={() =>
                                    setSidebarOpen(false)
                                }
                            />

                            <MobileNavLink
                                to={`/management`}
                                label="Projects"
                                onClick={() =>
                                    setSidebarOpen(false)
                                }
                            />

                            <div className="
                                my-3
                                border-t
                                border-gray-800
                            " />


                            <MobileNavLink
                                to="/signout"
                                label="Sign Out"
                                onClick={() =>
                                    logoutHandler()
                                }
                            />

                        </nav>


                        {/* USER */}

                        {userInfo && (

                            <div className="
                                mt-auto
                                justify-items-center
                                border-t
                                border-gray-800

                                p-4
                            ">

                                <div className="
                                    flex
                                    items-center
                                    gap-3
                                ">

                                    <div className="
                                        flex
                                        h-10
                                        w-10
                                        shrink-0

                                        items-center
                                        justify-center

                                        rounded-full

                                        bg-purple-600

                                        font-semibold
                                    ">
                                        {userInfo?.userName
                                            ?.charAt(0)
                                            ?.toUpperCase()}
                                    </div>


                                    <div className="
                                        min-w-0
                                    ">

                                        <p className="
                                            truncate
                                            text-sm
                                            font-medium
                                            text-white
                                        ">
                                            {userInfo?.userName}
                                        </p>

                                        <p className="
                                            truncate
                                            text-xs
                                            text-gray-500
                                        ">
                                            {userInfo?.email}
                                        </p>

                                    </div>

                                </div>

                            </div>

                        )}

                    </aside>

                </>

            )}

        </>
    )
}